export default "__VITE_ASSET__BLePf78s__"